<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="confirm-content">
      <p>确定删除商品规格</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteProductSpec">确认删除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteProductSpec } from '@/api/goods/productSpecApi'

export default {
  name: 'DeleteProductSpec',
  data() {
    return {
      dialogVisible: false,
      deleteProductSpecInfo: {}
    }
  },
  methods: {
    open(row) {
      this.deleteProductSpecInfo = { ...row }
      this.dialogVisible = true
    },
    async deleteProductSpec() {
      try {
        const res = await deleteProductSpec(this.deleteProductSpecInfo)
        
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除规格失败:', error)
      }
    },
    handleClose() {
      this.deleteProductSpecInfo = {}
    }
  }
}
</script>

<style scoped>
.confirm-content {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}
.dialog-footer {
  text-align: center;
}
</style>